import { personalInfo } from "../data/personalInfo";
import { socialLinks } from "../data/socialLinks";
import { ArrowUp, Mail, Phone, MapPin, ChevronRight } from "lucide-react";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-gray-950 text-white pt-20 pb-12 border-t border-gray-800/80 relative overflow-hidden">
      {/* Top Gradient Divider Line */}
      <div className="absolute top-0 inset-x-0 h-[2px] bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"></div>

      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* About Section */}
          <div className="col-span-1 lg:col-span-2">
            <h2 className="text-2xl font-bold font-heading bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 bg-clip-text text-transparent mb-3">
              {personalInfo.name}
            </h2>
            <p className="text-gray-400 mb-6 max-w-md text-sm leading-relaxed">
              Website & Mobile App Developer dedicated to crafting high-performance, responsive React, Next.js, and React Native applications.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-gray-900 hover:bg-indigo-600 flex items-center justify-center text-gray-300 hover:text-white transition-all duration-300 border border-gray-800 shadow-sm hover:scale-105"
                  aria-label={link.name}
                >
                  <span className="text-base">{link.icon}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-bold font-heading text-gray-400 tracking-widest uppercase mb-4">Quick Navigation</h3>
            <ul className="space-y-2.5">
              {["Home", "About", "Projects", "Contact"].map((item, index) => (
                <li key={index}>
                  <a 
                    href={`#${item.toLowerCase()}`}
                    className="text-gray-400 hover:text-indigo-400 transition-colors duration-300 flex items-center text-sm font-medium group"
                  >
                    <ChevronRight className="h-4 w-4 mr-1 text-gray-600 group-hover:text-indigo-400 transition-colors transform group-hover:translate-x-0.5" />
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xs font-bold font-heading text-gray-400 tracking-widest uppercase mb-4">Direct Contact</h3>
            <ul className="space-y-3.5">
              <li className="flex items-start text-sm">
                <Mail className="h-4.5 w-4.5 mr-3 text-indigo-400 shrink-0 mt-0.5" />
                <span className="text-gray-300 break-all text-xs sm:text-sm">{personalInfo.email}</span>
              </li>
              {personalInfo.phone && (
                <li className="flex items-start text-sm">
                  <Phone className="h-4.5 w-4.5 mr-3 text-indigo-400 shrink-0 mt-0.5" />
                  <span className="text-gray-300 text-xs sm:text-sm">{personalInfo.phone}</span>
                </li>
              )}
              <li className="flex items-start text-sm">
                <MapPin className="h-4.5 w-4.5 mr-3 text-indigo-400 shrink-0 mt-0.5" />
                <span className="text-gray-300 text-xs sm:text-sm">{personalInfo.location}</span>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Section with Copyright & Back to Top */}
        <div className="pt-8 border-t border-gray-800/80 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
          </p>
          
          <div className="flex items-center space-x-6">
            <p className="text-gray-500 text-xs hidden md:block">
              Built with React & Tailwind CSS
            </p>
            
            <button
              onClick={scrollToTop}
              className="p-2.5 rounded-xl bg-gray-900 hover:bg-indigo-600 text-gray-300 hover:text-white transition-all duration-300 border border-gray-800 shadow-md cursor-pointer"
              aria-label="Back to top"
            >
              <ArrowUp className="w-4 h-4 animate-bounce" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;